import { API_BASE } from '../config';
import { answerSummary, isMissingAnswer } from './surveySteps';

export default function SurveyAnswerReview({ steps, answers, readOnly, onEdit }) {
    const missing = steps.filter(({ question }) => question.required && isMissingAnswer(question, answers)).length;
    return (
        <section className="survey-review" aria-label="전체 답변 검토">
            <p className="survey-review-description">{readOnly ? '제출한 답변입니다.' : '작성한 답변을 확인해주세요. 수정할 문항을 선택하면 해당 문항으로 이동합니다.'}</p>
            {!readOnly && missing > 0 && <p className="survey-review-missing">필수 문항 {missing}개가 미응답 상태입니다.</p>}
            <ol className="survey-review-list">
                {steps.map(({ question }, index) => {
                    const summary = answerSummary(question, answers);
                    return (
                        <li key={question.question_id}>
                            <div className="survey-review-heading">
                                <h3>{index + 1}. {question.question_text}</h3>
                                {!readOnly && <button className="survey-text-button" aria-label={`${index + 1}번 답변 수정`} onClick={() => onEdit(index)}>수정</button>}
                            </div>
                            {Array.isArray(summary) && summary.length ? (
                                <div className="survey-review-images">{summary.map((item, i) => <figure key={i}>
                                    <img src={item.url.startsWith('http') ? item.url : `${API_BASE}${item.url}`} alt={`첨부 이미지 ${i + 1}`} />
                                    {item.text && <figcaption>{item.text}</figcaption>}
                                </figure>)}</div>
                            ) : <p className="survey-review-answer">{typeof summary === 'string' && summary.trim() ? summary : '미응답'}</p>}
                        </li>
                    );
                })}
            </ol>
        </section>
    );
}
